import React from 'react'
import Layout from '~components/shared/layout/layout'

export default function AppLayout({ children }) {
    return <Layout>{children}</Layout>
}
